const getSizes = (sizes) =>
  sizes.length > 0 ? [{ ...sizes[0], selected: true }, ...sizes.slice(1)] : [];

const reorderVariants = (variants) => {
  const index = variants.findIndex(({ id }) => id === 0);

  if (index >= 0) {
    const variant = variants[index];

    return variants
      .slice(0, index)
      .concat([...variants.slice(index + 1), variant]);
  }

  return variants;
};

const filterOneSizeFromVariants = (sizeVariants) => {
  const oneSizeVariant = sizeVariants.filter(
    (variant) => variant.name === 'OMNI'
  );
  if (oneSizeVariant.length === 0) {
    return sizeVariants;
  }

  /* "one Size"  is no logner  treated as variant .
    instead its style groups should be appended to remaining variant style groups
  */
  const oneSizeStyleGroups = oneSizeVariant
    .map((oneSizeVariant) => oneSizeVariant.styleGroups)
    .flat();
  const modifiedSizes = sizeVariants.reduce((variants, variant) => {
    if (variant.name !== 'OMNI') {
      variant.styleGroups = [...variant.styleGroups, ...oneSizeStyleGroups];
      variants.push(variant);
    }
    return variants;
  }, []);
  return modifiedSizes;
};

const getSizeVariants = (flattenedSize) => {
  const variants = flattenedSize.sizeOptions.reduce(
    (variants, variant) => ({
      ...variants,
      [variant.variantName]: [
        ...(variants[variant.variantName] ?? []),
        variant,
      ],
    }),
    {}
  );

  const sizes = Object.keys(variants).map((variant) => {
    const values = variants[variant];
    const variantId = parseInt(values?.[0]?.variantId);

    const styles = values.reduce(
      (styles, style) => ({
        ...styles,
        [style.sfcDimName]: [...(styles[style.sfcDimName] ?? []), style],
      }),
      {}
    );

    const styleGroups = Object.keys(styles).map((style) => {
      const value = styles[style];

      return {
        name: style,
        id: value.sfcId,
        sizes: value,
      };
    });

    return {
      id: variantId,
      name: variant,
      styleGroups,
    };
  });

  let modifiedSizes = sizes;

  //need to filter out "one size" variant  only when multiple size variants are present
  if (sizes.length > 1) {
    modifiedSizes = filterOneSizeFromVariants(sizes);
  }

  return getSizes(reorderVariants(modifiedSizes));
};

export default getSizeVariants;
